import validators from '../../../../utilities/validators';

const validator = (isCreation = true) =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('currency'),
        validators.requiredString('audience'),
        validators.requiredString('flag3ds'),
        validators.requiredString('apiKey'),
        validators.requiredString('officeId'),
        validators.requiredString('paymentEndpoint'),

        validators.only(
            () => isCreation,
            validators.compose(
                validators.requiredString('signingPrivateKey'),
                validators.requiredString('signingPublicKey'),
                validators.requiredString('encryptionPrivateKey'),
                validators.requiredString('encryptionPublicKey')
            )
        ),

        validators.requiredString('kid')
    );

export default validator;
